<template>
  <div>
    <jc-dialog :visible.sync="validateDialog" size="small" :title="text.dialogTitle" :modal-append-to-body='false' :close-on-click-modal="false" @close="cancel">
      <jc-form :model="form" label-width="150px" class="jc-form-tiny-width jc-form-large-size">
        <jc-form-item :label="text.dialogFee">
          <span>{{form.fee}}</span>
        </jc-form-item>
        <jc-form-item :label="$t('有效时间')">
          <span>{{form.time}}</span>
        </jc-form-item>
        <jc-form-item :label="`${$t('发放账号')}${$t('：')}`">
          <span>{{form.pointUser}}</span>
        </jc-form-item>
        <jc-form-item :label="`${$t('手机号')}${$t('：')}`"  v-if="security">
          
              <p style="color: #9e9e9e;float:left">{{form.mobile | codeString(3,4)}}</p>
            
              <a :href="LINK.modifyPhone" style="margin-left:10px" target="_blank">{{$t('更换绑定手机')}}</a>
          
        </jc-form-item>
        <jc-form-item :label="$t('短信验证码_')" v-if="security">
               <jc-input v-model="form.verifyCode" auto-complete="off" style="width: 40%;"></jc-input>
               <jc-button type="primary" v-if="codeBtn" disabled
                    >{{`${$t('重新发送')} ${ time } s`}}</jc-button
                  >
               <jc-button v-else type="primary" @click="getCode" class="code" style="width: 35%; margin-left:10px">{{$t('获取短信验证')}}</jc-button>
        </jc-form-item>
      </jc-form>
      <div slot="footer" class="dialog-footer">
        <jc-button @click="cancel">{{$t('取消')}}</jc-button>
        <jc-button type="primary" class="issue" @click="submit">{{$t('确定')}}</jc-button>
      </div>
    </jc-dialog>
  </div>
</template>
<script>
import { LINK, ISSUE_TEXT } from '@/utils/constant.js'
import { sendValidateCode, describeBaseInfo } from '@/api/coupon-api.js'

export default {
  name: 'validate-dialog',
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String
    },
    security: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      LINK,
      ISSUE_TEXT,
      validateDialog: false,
      text: ISSUE_TEXT.issue,
      form: {
        mobile: '',
        verifyCode: ''
      },
      codeBtn: false,
      time: 60,
      source: 'couponDeliver'
    }
  },
  watch: {
    info: {
      handler(val) {
        this.form = Object.assign(this.form, val)
      },
      deep: true
    }
  },
  methods: {
    async getCode() {
      if (this.time === 60) {
        let { mobile, fee, time, pointUser } = this.form
        let params = {
          mobile,
          source: this.source,
          fee,
          validate: time,
          pointUser
        }
        await sendValidateCode(params)
        this.CountPhoneTime()
      }
    },
    submit() {
      this.$emit('submit', this.form)
    },
    cancel() {
      this.form.verifyCode = ''
      this.validateDialog = false
    },
    async getMobile() {
      let {
        body: {
          result: { cscPhone }
        }
      } = await describeBaseInfo()
      this.form.mobile = cscPhone
    },
    CountPhoneTime() {
      this.time = 60
      this.codeBtn = true
      var timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          clearInterval(timer)
          this.time = 60
          this.codeBtn = false
        }
      }, 1000)
    }
  },
  created() {
    if (this.type === 'issue') {
      this.text = ISSUE_TEXT.issue
      this.source = 'couponDeliver'
    } else {
      this.text = ISSUE_TEXT.resend
      this.source = 'quotaResend'
    }
    this.getMobile()
  }
}
</script>
